<template>
  <div class="landing">
      <div class="pattern">
        <div class="top-gradient">
          <div class="container">
            <h1>Developer. Musician. Human.</h1>
            <hr>
            <p>I make things with code and sound.</p>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'Landing'
}
</script>
